import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { NumberInput, TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function OffreFrequenceFields({ item, set, tab }) {
    const t = useTranslations()
    return <>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} max="999" required />
            <NumberInput label={t("Fréquence")} value={item.frequences} onChange={set('frequences')} required step="0.01" />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Nom FR")} value={item.nomFr} onChange={set('nomFr')} required />
            <TextInput className="grow" label={t("Nom NL")} value={item.nomNl} onChange={set('nomNl')} />
            <TextInput className="grow" label={t("Nom EN")} value={item.nomEn} onChange={set('nomEn')} />
        </Row>
    </>
}

export function OffreFrequencesList(props) {
    const t = useTranslations()
    return <ListPage model="offreFrequences" title={t("Fréquences")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Nom FR')]: 'nomFr',
        [t('Nom NL')]: 'nomNl',
        [t('Nom EN')]: 'nomEn',
        [t('Fréquence')]: 'frequences',
    }} {...props} />
}

export function OffreFrequenceDetail(props) {
    const t = useTranslations()
    return <DetailPage model="offreFrequences" title={t("Fréquence")} Fields={OffreFrequenceFields} {...props} />
}
